import { DocumentReference } from "firebase/firestore";
import { Button, Card } from "antd";
import { VFC } from "react";
import { Game } from "../../../../utils/Game";
import { InventedNameModal } from "../GameMember/InventedNameModal";
import { useSetStatusToPlayMutation } from "../../../../utils/useSetStatusToPlayMutation";
import { QuestionButton } from "../../../QuestionButton";

export const GameMasterStatusWaitForNames: VFC<{
  gameRef: DocumentReference;
  small: boolean;
  game: Game;
}> = ({ gameRef, game, small }) => {
  const startMutation = useSetStatusToPlayMutation({ gameRef });

  const members = Object.values(game?.membersMap ?? []);

  const allNamesSetted = members.every((member) => !!member.inventedName);
  return (
    <>
      <InventedNameModal />
      <Card
        size={"small"}
        title={small ? undefined : "Wartet auf den Spielstart"}
        extra={small ? undefined : <QuestionButton />}
      >
        <p> Wenn alle die namen eingetragen haben, kann es los gehen.</p>
        <Button
          block
          type={"primary"}
          onClick={() => {
            startMutation.mutate();
          }}
          disabled={!allNamesSetted || startMutation.isLoading}
        >
          Starten
        </Button>
      </Card>
    </>
  );
};
